export const carbonFilter = () => {
  const filterSwitch = document.querySelector('.main-checkBox .switch #basCarbon')
  const needSections = document.querySelectorAll('.text_visuel [data-carbone="0"]')

  if (filterSwitch && needSections?.length) {
    filterSwitch.addEventListener('change', () => {
      needSections.forEach((section, index) => {
        if (filterSwitch.checked) {
          section.closest('.section_content').classList.add('hide')
        } else {
          section.closest('.section_content').classList.remove('hide')
        }
      })
    })
  }
}
